import { TFunction } from 'i18next';

import type { SelectOption } from '@/shared/ui';
import { SERVICE_REQUEST_STATUS, type ServiceRequestStatus } from '@/entities/service-request';

export const getServiceRequestStatusOptions = (t: TFunction): SelectOption<ServiceRequestStatus | string>[] => [
  { value: SERVICE_REQUEST_STATUS.ALL, label: t('common.all', 'All') },
  { value: SERVICE_REQUEST_STATUS.PENDING, label: t('onlinesrf.status.P.name') },
  { value: SERVICE_REQUEST_STATUS.VERIFIED, label: t('onlinesrf.status.V.name') },
  { value: SERVICE_REQUEST_STATUS.ACCEPTED, label: t('onlinesrf.status.A.name') },
  { value: SERVICE_REQUEST_STATUS.REJECTED, label: t('onlinesrf.status.R.name') }
];
